export default __webpack_public_path__ + "static/media/SkillsPhDProgressionIllustration.e1673eea.svg";